<div class="form-container">
  <qform-form-header
    [title]="headerTitle"
    [subtitle]="flowName"
    [dropdownItems]="headerDropdownUrls">
  </qform-form-header>

  <div class="form-render-content">
    <app-form-render-component
      [formComponents]="formComponents"
    ></app-form-render-component>
  </div>

  @if (isEditForm) {
    <qform-buttons-container [buttonsList]="[
      { value: _localizationService.localize('Save'), key: 'save' }
    ]" (optionSelected)="saveFlowForm()"></qform-buttons-container>
  }
</div>

